import { render, staticRenderFns } from "./expiredReservations.vue?vue&type=template&id=464dc2f4&"
import script from "./expiredReservations.vue?vue&type=script&lang=js&"
export * from "./expiredReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports